@if (profileField$ | async; as profileField) {
  <sh-form-multi-select
    [id]="id"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [options]="webserviceOptions$ | async"
    [control]="jdnProjectControl"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [canBeIndeterminate]="true"
    [indeterminateMsg]="'general.different-values' | translate"
    [searchPlaceholderMsg]="'ui.search' | translate"
    [noResultsFoundMsg]="'ui.no-results' | translate"
    [listCappedMsg]="'ui.capped-results' | translate"
    [multiple]="false"
    [search]="true"
    [disabledMsg]="disabledMessageKey | translate"
    (searchTerm)="onSearchTermChange($event)"
    >
    <ng-content></ng-content>
  </sh-form-multi-select>
}
